import { defineMessages } from '@atlassian/jira-intl';

export default defineMessages({
	daysShort: {
		id: 'software-cycle-time-breakdown-report.common.days-short',
		defaultMessage: '{days}{days, plural, one {d} other {d}}',
		description:
			'Days with abbreviation such as "d". Will be shown as a duration e.g. "2d 14hrs median cycle time"',
	},
	days: {
		id: 'software-cycle-time-breakdown-report.common.days',
		defaultMessage: '{days} {days, plural, one {day} other {days}}',
		description: 'Days will be shown as a duration e.g. "2 days 14 hrs median cycle time"',
	},
	hoursShort: {
		id: 'software-cycle-time-breakdown-report.common.hours-short',
		defaultMessage: '{hours}{hours, plural, one {hr} other {hrs}}',
		description:
			'Hours with abbreviation such as hrs. Depending on the target language, this may not/may need abbreviation.',
	},
	hours: {
		id: 'software-cycle-time-breakdown-report.common.hours',
		defaultMessage: '{hours} {hours, plural, one {hour} other {hours}}',
		description: 'Hours',
	},
	lessThanOneHour: {
		id: 'software-cycle-time-breakdown-report.common.less-than-one-hour',
		defaultMessage: '< 1 hr',
		description: 'less than one hour cycle-time',
	},
	branchCount: {
		id: 'software-cycle-time-breakdown-report.common.branch-count',
		defaultMessage: '{value} {value, plural, one {branch} other {branches}}',
		description: 'counts for source code branches',
	},
	commitCount: {
		id: 'software-cycle-time-breakdown-report.common.commit-count',
		defaultMessage: '{value} {value, plural, one {commit} other {commits}}',
		description: 'counts for commits of the source code',
	},
	pullRequestsCountShort: {
		id: 'software-cycle-time-breakdown-report.common.pull-requests-count-short',
		defaultMessage: '{value} {value, plural, one {PR} other {PRs}}',
		description:
			'counts for pull request of the source code branch. Depending on the target language, this may not/may need abbreviation.',
	},
	pullRequestsCount: {
		id: 'software-cycle-time-breakdown-report.common.pull-requests-count',
		defaultMessage: '{value} {value, plural, one {pull request} other {pull requests}}',
		description: 'counts for pull request of the source code branch',
	},
	buildCount: {
		id: 'software-cycle-time-breakdown-report.common.build-count',
		defaultMessage: '{value} {value, plural, one {build} other {builds}}',
		description: 'counts for build of the source code',
	},
	under: {
		id: 'software-cycle-time-breakdown-report.common.under',
		defaultMessage: 'under',
		description:
			'This word is used to show cycle time comparison, when the current cycle time is under the past cycle time, which is getting better',
	},
	over: {
		id: 'software-cycle-time-breakdown-report.common.over',
		defaultMessage: 'over',
		description:
			'This word is used to show cycle time comparison, when the current cycle time is over the past cycle time, which is getting worse',
	},
	equal: {
		id: 'software-cycle-time-breakdown-report.common.equal',
		defaultMessage: 'equal',
		description:
			'This word is used to show cycle time comparison, when the current cycle time is equal to the past cycle time.',
	},
	learnMore: {
		id: 'software-cycle-time-breakdown-report.common.learn-more',
		defaultMessage: 'Learn more',
		description: 'Learn more link to lead the user to the detail documentation',
	},
	medianCycleTime: {
		id: 'software-cycle-time-breakdown-report.common.median-cycle-time',
		defaultMessage: 'median cycle time',
		description: 'Will be used to display a duration e.g. 2 days 14 hrs median cycle time',
	},
});
